import { render, staticRenderFns } from "./CragGradeProtectionActionRequired.vue?vue&type=template&id=a0d2371a"
import script from "./CragGradeProtectionActionRequired.vue?vue&type=script&lang=js"
export * from "./CragGradeProtectionActionRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports